module.exports = __webpack_public_path__ + "img/thumb-designerzy-zycia.jpg";